export default "__VITE_ASSET__C_LfNA0Q__"